import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-pipeline-status',
  templateUrl: './modal-pipeline-status.component.html',
  styleUrls: ['./modal-pipeline-status.component.scss']
})
export class ModalPipelineStatusComponent implements OnInit {

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
  }

}
